import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const EMPTY = { plan: 'launch', limits: {}, scans: [], keywords: [], prospects: [], optimization: null, records: [], generations: [] };

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('dt_token')}`, 'Content-Type': 'application/json' });

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspace] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    try {
      const response = await fetch(`${API}/workspace`, { headers: authHeaders() });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Could not load your workspace.');
      setWorkspace({ ...EMPTY, ...data });
      setError('');
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => ({ workspace, loading, error, reload }), [workspace, loading, error, reload]);
  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace() {
  const context = useContext(WorkspaceContext);
  if (!context) throw new Error('useWorkspace must be used inside WorkspaceProvider');
  return context;
}
